import { computeStreamTypingDuration } from './computeStreamTypingDuration.js'
import { scaleChatStreamContentDelay } from './chatStreamSpeed.js'
import {
  expandTextToLines,
  joinLines,
  planCharRevealSteps,
  planLineRevealInterval,
  splitTextLines,
} from './runTypewriterHelpers.js'

export function runTypewriter(opts) {
  const { session, signal, text, onUpdate, onDone } = opts
  const minStepIntervalMs = opts.minStepIntervalMs ?? 1
  const lineBreak = opts.lineBreak ?? 'preserve'
  const mode = opts.mode ?? (text.includes('\n') ? 'line' : 'char')
  const durationMs =
    opts.durationMs ?? scaleChatStreamContentDelay(computeStreamTypingDuration(text.length))

  if (!text.length) {
    onUpdate('')
    onDone()
    return
  }

  if (mode === 'line') {
    const lines =
      lineBreak === 'preserve' ? splitTextLines(text) : expandTextToLines(text, lineBreak)
    const lineDurationMs = Math.max(durationMs, lines.length * minStepIntervalMs)
    const intervalMs = planLineRevealInterval(lines.length, lineDurationMs, minStepIntervalMs)
    let lineIdx = 0

    const step = () => {
      if (signal.aborted) {
        session.dispose()
        return
      }

      lineIdx = Math.min(lines.length, lineIdx + 1)
      onUpdate(joinLines(lines, lineIdx))

      if (lineIdx < lines.length) {
        session.addTimeout(step, intervalMs)
        return
      }

      onDone()
    }

    step()
    return
  }

  const granularity = opts.granularity ?? 'bulk'
  const { intervalMs, charsPerStep } =
    granularity === 'character'
      ? {
          intervalMs: Math.max(minStepIntervalMs, Math.floor(durationMs / Math.max(1, text.length))),
          charsPerStep: 1,
        }
      : planCharRevealSteps(text.length, durationMs, minStepIntervalMs)
  let idx = 0

  const step = () => {
    if (signal.aborted) {
      session.dispose()
      return
    }

    idx = Math.min(text.length, idx + charsPerStep)
    onUpdate(text.slice(0, idx))

    if (idx < text.length) {
      session.addTimeout(step, intervalMs)
      return
    }

    onDone()
  }

  step()
}
